// src/components/Reports/AdditionalReports.jsx
import React, { Component } from "react";
import axios from "axios";
import Config from "../../config";
import { Select, Button, Table, Input,Row } from "antd";
import moment from "moment";

const { Option } = Select;

class AdditionalReports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reports: [],
      selectedCode: "",
      files: [],
      loading: false,
      error: null,
      hasViewed: false,
    };
  }

  componentDidMount() {
    this.loadReports();
  }

  loadReports = async () => {
    
    this.setState({ loading: true, error: null });
    try {
      const res = await axios.get(`${Config.Report}/GetAdditionalMasterReport`, {
        headers: {
          Authorization: sessionStorage.getItem("access_token"),
        },
      });
      const body = res.data;
      if (!body.success) throw new Error(body.message || "Failed to load reports");
      const list = body.data || [];
      this.setState({
        reports: list,
        selectedCode: list.length > 0 ? list[0].reportCode : "",
        loading: false,
      });
    } catch (err) {
      this.setState({ error: err.message, loading: false });
    }
  };

  GetAdditionalFiles = async () => {
    const { selectedCode } = this.state;
    if (!selectedCode) return;
    this.setState({ loading: true, error: null, hasViewed: true, files: [] });
    try {
      const res = await axios.get(`${Config.Report}/GetAdditionalFiles/${selectedCode}`, {
        headers: {
          Authorization: sessionStorage.getItem("access_token"),
        },
      });
      const body = res.data;
      if (!body.success) throw new Error(body.message || "Failed to load files");
      this.setState({ files: body.data || [], loading: false });
    } catch (err) {
      this.setState({ files: [], error: err.message, loading: false });
    }
  };

  handleDownload = (file) => {
    const { selectedCode } = this.state;
    const url = `${Config.Report}/DownloadAdditionalFile/${file.ReportFileId}`;
    window.location.href = url;
  };

  render() {
    const { reports, selectedCode, files, loading, error, hasViewed } = this.state;

    return (
      <div style={{  fontFamily: "Segoe UI, Arial, sans-serif" }}>
        <div className="square-blue-profile-listuser-1" >
         </div>
   <div className="square-white-profile-listuser-1 mx-4 px-4 pt-2 pb-4" >
        <div style={{ display: "flex", gap: 12, alignItems: "center", marginBottom: 5,padding:10 }}>
          <label style={{ fontWeight: 600 }}>Select report:</label>
          <Select
            value={selectedCode || undefined}
            onChange={(v) =>
              this.setState({
                selectedCode: v,
                files: [],
                hasViewed: false,
                error: null,
              })
            }
            loading={loading && reports.length === 0}
            style={{ minWidth: 300 }}
            placeholder="Choose a report"
          >
            {reports.map((r) => (
              <Option key={r.ReportCode} value={r.ReportCode}>
                {r.DisplayName}
              </Option>
            ))}
          </Select>

          <Button type="primary" onClick={this.GetAdditionalFiles} loading={loading} disabled={!selectedCode}>
            View
          </Button>
        </div>

        {error && <div style={{ color: "#b00020", marginBottom: 2 }}>{error}</div>}

        {hasViewed && !loading && files.length === 0 && !error && (
          <p>No files available for this report.</p>
        )}
       
        </div>

        {files.length > 0 && (
          <Table
            rowKey="reportFileId"
            size="small"
            pagination={{ pageSize: 15, showSizeChanger: false }}
            columns={[
 {
    title: "#",
    key: "index",
    width: 60,
    align: "center",
    render: (_, __, index) => index + 1,
  },

              { title: "File Name", dataIndex: "FileName", key: "FileName" },
              {
                title: "File Date",
                dataIndex: "FileDate",
                key: "FileDate",
                render: (v) => (v ? moment(v).format("MM/DD/YYYY") : ""),
              },
              {
                title: "Received",
                dataIndex: "ReceivedUtc",
                key: "ReceivedUtc",
                render: (v) => (v ? moment(v).format("MM/DD/YYYY HH:mm") : ""),
              },
              {
                title: "Size",
                dataIndex: "FileSize",
                key: "FileSize",
                render: (v) => formatSize(v),
              },
              {
                title: "Action",
                key: "action",
                render: (_, file) =>
                  file.IsDownloadable ? (
                    <Button type="link" onClick={() => this.handleDownload(file)}>
                      Download
                    </Button>
                  ) : (
                    <span style={{ color: "#999" }}>Unavailable</span>
                  ),
              },
            ]}
            dataSource={files}
          />
        )}
      </div>
    );
  }
}

function formatSize(bytes) {
  if (bytes == null) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(2)} MB`;
}

export default AdditionalReports;